import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Reunimos algumas dicas que podem melhorar seu perfil e atrair mais pacientes. ", -1)
const _hoisted_5 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_6 = { class: "text-subtitle text-success" }
const _hoisted_7 = { class: "text-subtitle" }
const _hoisted_8 = { class: "progress" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "d-flex justify-content-between align-items center" }
const _hoisted_13 = {
  key: 0,
  class: "fa-solid fa-check-circle text-success"
}
const _hoisted_14 = {
  key: 1,
  class: "fa-regular fa-check-circle"
}
const _hoisted_15 = {
  key: 2,
  class: "ms-2 badge bg-info rounded-4"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right ms-auto text-subtitle" }, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "my-4"
}
const _hoisted_18 = { class: "card" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0" }, "Outras sugestões")
], -1)
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = { class: "text-subtitle mb-0" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-check-circle" }, null, -1)
const _hoisted_23 = { class: "text-paragraph mb-0" }
const _hoisted_24 = {
  key: 0,
  class: "my-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.session?.profile_improvement_values?.concludedCount) + " concluídas ", 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.session?.profile_improvement_values?.concludedCount) + "/" + _toDisplayString(_ctx.session?.profile_improvement_values?.totalCount), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "progress-bar bg-success",
            role: "progressbar",
            style: _normalizeStyle({
              width: `${_ctx.session?.profile_improvement_values?.percentage}%`,
            })
          }, null, 4)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.improvements, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass({
            'cursor-pointer': item.enabled,
          }),
            onClick: ($event: any) => (item.enabled ? item.action() : null)
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", {
                class: _normalizeClass(["text-subtitle mb-0", { 'text-muted': item.premium && !item.enabled }])
              }, [
                (_ctx.session?.profile_improvement[item.key])
                  ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                  : (_openBlock(), _createElementBlock("i", _hoisted_14)),
                _createTextVNode(" " + _toDisplayString(item.title) + " ", 1),
                (item.premium && !item.enabled)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Paiapp +"))
                  : _createCommentVNode("", true)
              ], 2),
              _hoisted_16
            ]),
            _createElementVNode("p", {
              class: _normalizeClass(["text-paragraph mb-0", { 'text-muted': item.premium && !item.enabled }])
            }, _toDisplayString(item.description), 3),
            (index + 1 !== _ctx.improvements.length)
              ? (_openBlock(), _createElementBlock("hr", _hoisted_17))
              : _createCommentVNode("", true)
          ], 10, _hoisted_11))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("p", _hoisted_21, [
              _hoisted_22,
              _createTextVNode(" " + _toDisplayString(item.title), 1)
            ]),
            _createElementVNode("p", _hoisted_23, _toDisplayString(item.description), 1),
            (index + 1 !== _ctx.suggestions.length)
              ? (_openBlock(), _createElementBlock("hr", _hoisted_24))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}